import { runtimeEnv } from './runtimeEnv';

export const API_BASE = runtimeEnv.apiUrl;

const buildSocketUrl = () => {
	if (runtimeEnv.socketUrl) return runtimeEnv.socketUrl;
	// Use browser origin so the WebSocket goes through Traefik on the standard
	// HTTPS port — the /socket.io path prefix is handled by the router.
	const loc = (typeof window !== 'undefined' && window.location) ? window.location : new URL(API_BASE);
	const proto = loc.protocol === 'https:' ? 'wss:' : 'ws:';
	return `${proto}//${loc.host}`;
};

export const SOCKET_URL = buildSocketUrl();

export const apiUrl = (path: string) => `${API_BASE}${path}`;

export const getAuthHeaders = (token?: string) =>
	token
		? {
				Authorization: `Bearer ${token}`,
			}
		: {};
